import NextImage, { ImageProps as NextImageProps } from 'next/image';
import { useState } from 'react';

import './Image.scss';

const DEFAULT_SIZE = 200;

interface CustomImageProps extends Partial<NextImageProps> {
  src: string;
  size?: number;
}

const Image = ({
  src,
  className,
  size = DEFAULT_SIZE,
  ...props
}: CustomImageProps) => {
  const [loaded, setLoaded] = useState(false);

  const showSkeleton = !src || !loaded;

  const getOptimizedSrc = (_src: string) => {
    if (_src?.includes('contents.mediadecathlon.com')) {
      const url = new URL(_src);
      url.searchParams.set('format', 'auto');
      url.searchParams.set('f', `${size}x0`);
      return url?.toString() || _src;
    }

    return _src;
  };

  return (
    <div
      className={`image-skeleton-wrapper ${showSkeleton ? 'is-loading' : ''}`}
      style={{
        width: props?.width,
        height: props?.height,
        minWidth: props?.width,
        minHeight: props?.height,
      }}
    >
      <NextImage
        {...props}
        alt={props?.alt || ''}
        className={`${className} ${loaded ? 'is-visible' : 'is-hidden'}`}
        src={getOptimizedSrc(src)}
        width={Number(props?.width) || size}
        height={Number(props?.height) || size}
        onLoad={() => setLoaded(true)}
        unoptimized
      />
    </div>
  );
};

export default Image;
